export interface HostMarkProps {
  readonly name: string;
  readonly logoUrl: string | null;
}

export function HostMark({ name, logoUrl }: HostMarkProps) {
  return logoUrl ? (
    <img class="d-host-logo" src={logoUrl} alt={name} />
  ) : (
    <span class="d-host-name">{name}</span>
  );
}
